import React from 'react';
import './LegalPages.css';

function Compliance({ onBack }) {
  return (
    <section className="legal-page">
      <div className="legal-container">
        <button className="back-button" onClick={onBack}>← Back</button>
        
        <h1>Compliance</h1>
        <p><strong>Last Updated: April 2026</strong></p>

        <h2>1. Regulatory Framework</h2>
        <p>
          Northstar Bridge Commerce LLC operates in compliance with federal, state, and local regulations 
          governing wholesale commerce and business-to-business transactions.
        </p>

        <h2>2. Business Licensing</h2>
        <p>
          Our company maintains appropriate business licenses and registrations required 
          to operate as a wholesale commerce platform in Delaware and the United States.
        </p>

        <h2>3. Tax Compliance</h2>
        <p>
          We comply with all applicable tax laws including federal income tax, state tax obligations, 
          and sales tax collection requirements for jurisdictions where applicable.
        </p>

        <h2>4. Data Protection and Privacy</h2>
        <p>
          Our data handling practices comply with relevant privacy regulations. We protect personal 
          information in accordance with our Privacy Policy and applicable data protection laws.
        </p>

        <h2>5. Anti-Money Laundering (AML)</h2>
        <p>
          Northstar Bridge Commerce LLC maintains policies to prevent money laundering and 
          compliance with OFAC (Office of Foreign Assets Control) regulations.
        </p>

        <h2>6. Export Control</h2>
        <p>
          All international transactions comply with U.S. export control regulations and sanctions programs. 
          We do not engage in business with sanctioned entities or individuals.
        </p>

        <h2>7. Labor and Employment</h2>
        <p>
          Our employment practices comply with federal labor laws, including wage and hour requirements, 
          workplace safety, and non-discrimination standards.
        </p>

        <h2>8. Product Safety and Quality</h2>
        <p>
          Products and services offered through our platform meet applicable safety and quality standards. 
          We work with suppliers who maintain compliance with relevant product regulations.
        </p>

        <h2>9. Intellectual Property</h2>
        <p>
          We respect intellectual property rights and comply with copyright, trademark, and patent laws. 
          Our platform content and branding are protected intellectual property.
        </p>

        <h2>10. Anti-Corruption</h2>
        <p>
          We maintain strict anti-corruption policies prohibiting bribery, kickbacks, and improper payments 
          in accordance with federal and international anti-corruption laws.
        </p>

        <h2>11. Environmental Compliance</h2>
        <p>
          Our operations comply with applicable environmental regulations and sustainability standards 
          to the extent applicable to our business activities.
        </p>

        <h2>12. Contact for Compliance Matters</h2>
        <p>
          For compliance-related inquiries or concerns, please contact:<br />
          <strong>Northstar Bridge Commerce LLC</strong><br />
          Email: <a href="mailto:sales@northstarbridgeco.com">sales@northstarbridgeco.com</a><br />
          Phone: <a href="tel:+13023858016">+1 302 385 8016</a>
        </p>
      </div>
    </section>
  );
}

export default Compliance;
